import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Analytics } from '../lib/firebase-analytics';

export function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    // Get page name from pathname
    const pageName =
      location.pathname === '/' ? 'home' : location.pathname.slice(1);
    Analytics.logPageView(pageName);
  }, [location]);
}

export function useFeatureTracking() {
  return {
    trackFeature: (feature, action) => {
      Analytics.logFeatureInteraction(feature, action);
    }
  };
}
